import React, { useState } from 'react';
import Switch from "react-bootstrap-switch";
import { CardBody,  Col, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { connect } from "react-redux";

import { useForm } from "react-hook-form";
import { ButtonClean, ButtonSearch } from "../../../components/buttons/buttonsActions";
import {FL_CODE, FL_NAME, FL_STATUS} from "../../../components/i18n/formLabels";
import {PH_SEARCH_CODE, PH_SEARCH_NAME} from "../../../components/i18n/placeHolders";
import { setFilter } from "../../../redux/actions/generalActions/listActions";

const AirlineFilters = props => {
    const { filter } = props.listProps

    const [status, setStatus] = useState(filter?.status != null ? filter?.status : null)
    const [resetValue, setResetvalue] = useState(false)
    const {register, handleSubmit, reset} = useForm({
        defaultValues:{
            code: filter?.code,
            name: filter?.name,
        }
    });

    const onSubmit = (data, _) => {
        const dataFilter = {
            fbDataBase : { id : props.mainProps?.app?.fbDataBase?.id },
            item :  {
                code : data.code,
                name : data.name,

            }
        };

        dataFilter.item.status = status;

        props.setFilter(dataFilter);
        props.refreshFiltered(dataFilter);
    };

    const cleanFields = () => {
        setStatus(null);
        setResetvalue(!resetValue);
        props.setFilter({
            fbDataBase : { id : props.mainProps?.app?.fbDataBase?.id },
            item : { code : null, name: null }
        });
        reset();
    }

    return (
        <Form onSubmit={handleSubmit(onSubmit)}>
            <CardBody>
                <Row>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_CODE}</Label>
                            <Input
                                type="text"
                                name="code"
                                placeholder={PH_SEARCH_CODE}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="3">
                        <FormGroup>
                            <Label>{FL_NAME}</Label>
                            <Input
                                type="text"
                                name="name"
                                placeholder={PH_SEARCH_NAME}
                                innerRef={register}
                            />
                        </FormGroup>
                    </Col>
                    <Col md="2">
                        <FormGroup>
                            <Label>{FL_STATUS}</Label>
                            <br/>
                            <Switch
                                animate={true}
                                offText={"No"}
                                onText={"Si"}
                                value={status}
                                onChange={ () => setStatus(!status) }
                            />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md="12" className="d-flex justify-content-center">
                        <div className="float-right">
                            <ButtonSearch/>
                            <ButtonClean onClick={() => cleanFields()}/>
                        </div>
                    </Col>
                </Row>
            </CardBody>
        </Form>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    listProps: state.listProps,
})

const mapActionsToProps = ({
    setFilter,
})

export default connect(mapStateToProps, mapActionsToProps)(AirlineFilters)